import { baseApi } from '@/services/api';
import { CreateCustomRequest, CustomCategory, CustomsResponse, GetCustomsParams, ManualCustomRequest, UpdateCustomRequest, Venue } from './nestedTypes';
import { Custom } from './nestedTypes';
import { updateNested } from './nestedSlice';

// Get user role from Redux
const user = localStorage.getItem('authUser') ? JSON.parse(localStorage.getItem('authUser')!) : null;
const userRole = user?.userType || null;
export const nestedAPI = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        // ✅ Get customs (with proper params)
        getNesteds: builder.query<CustomsResponse, GetCustomsParams | any>({
            query: (params = {}) => ({
                url: `/nestedapi/${userRole}/${params}`,
                method: 'GET',

            }),
            providesTags: (result) =>
                result?.data
                    ? [
                        ...result.data.map(({ event_id }) => ({
                            type: 'Customs' as const,
                            id: event_id,
                        })),
                        { type: 'Customs', id: 'LIST' },
                    ]
                    : [{ type: 'Customs', id: 'LIST' }],
        }),

        // ✅ Get Single Custom
        getNested: builder.query<Custom, GetCustomsParams | any>({
            query: (id) => ({
                url: `/nestedapi/${userRole}/${id}`,
                method: 'GET',
            }),
            providesTags: (result, error, id) => [{ type: 'Events', id }],
        }),

        // ✅ Create Event (AI-generated)
        createNested: builder.mutation<Custom, GetCustomsParams | any>({
            query: (params) => ({
                url: `/nestedapi/${userRole}/${params?.path}`,
                method: 'POST',
                data: params?.data,
            }),
            //invalidatesTags: [{ type: 'Events', id: 'LIST' }],
        }),

        // ✅ Create Event (Manual)
        createManualNested: builder.mutation<Custom, any>({
            query: (event) => ({
                url: '/contacts',
                method: 'POST',
             data: event ,
            }),
            //invalidatesTags: [{ type: 'Events', id: 'LIST' }],
        }),

        // ✅ Update Event
        updateNested: builder.mutation<Custom, { id: any; data: UpdateCustomRequest }>({
            query: ({ id, data }) => ({
                url: `/nestedapi/${userRole}/${id}`,
                method: 'PUT',
                data,
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'Events', id },
                { type: 'Events', id: 'LIST' },
            ],
        }),

        // ✅ Delete Event
        deleteNested: builder.mutation<void, string>({
            query: (id) => ({
                url: `/nestedapi/${userRole}/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [{ type: 'Events', id: 'LIST' }],
        }),


    }),
});

export const {
    useGetNestedsQuery,
    useLazyGetNestedsQuery,
    useGetNestedQuery,
    useCreateNestedMutation,
    useCreateManualNestedMutation,
    useUpdateNestedMutation,
    useDeleteNestedMutation,

} = nestedAPI;
